import Head from 'next/head';
import Image from 'next/image';
import styles from '../../styles/sass/pages/Service.module.scss'
import useWindowSize from '../../util/useWindowSize'
import CtaCard from '../../components/layout/ctaCard'

export default function PersonalConsueling() {
    const size = useWindowSize();

    return (
        <>
            <Head>
                <title>Szolgáltatások - Személyes tanácsadás | Szabó Jennifer Pszichológus</title>
                <meta name="description" content="A személyes ülések biztonságos 
                teret biztosítanak az érzelmek és a személyes tapasztalatok felfedezésére." />
                <meta property="og:title" content="Szolgáltatások - Személyes tanácsadás | Szabó Jennifer Pszichológus" />
                <meta property="og:type" content="article" />
                <meta property="og:description" content="A személyes ülések biztonságos teret 
                biztosítanak az érzelmek és a személyes tapasztalatok felfedezésére." />
                <meta property="og:url" content="https://szabojennifer.hu/szolgaltatasok/szemelyes-tanacsadas" />
                <meta property="og:image" content="/img/szolgaltatasok/szemelyes-tanacsadas-hero.png" />
                <meta property="og:image:alt" content="Pszichológiai tanácsadás közben jegyzetelő kéz" />
            </Head>
            <main>
                <div className={styles.serviceHeroContainer}>
                    <div className={styles.serviceHero}>
                        <div className={styles.serviceImageSide}>
                            <div className={styles.serviceImageContainer}>
                                <Image
                                    src="/img/szolgaltatasok/szemelyes-tanacsadas-hero.png"
                                    className={styles.heroImg}
                                    width={825}
                                    height={550}
                                    alt="Pszichológiai tanácsadás közben jegyzetelő kéz"
                                />
                                <div className={styles.serviceHeadingSide}>
                                    <h1 className={styles.serviceHeading}>
                                        Személyes tanácsadás
                                    </h1>
                                    {size.width > 1344 &&
                                        <>
                                            <p className={styles.serviceHeadingLead}>
                                                A személyes ülések biztonságos teret biztosítanak az érzelmek és a személyes tapasztalatok felfedezésére.
                                                A közös munka lehetőséget teremt a hatékonyabb megküzdési készségek kialakítására a mindennapi élet kihívásival szemben és eszközöket kínál az egészségesebb kapcsolati működésre.
                                                A tanácsadás során nemcsak a nehézségeknek van tere, kiemelt szerepet kapnak az erőforrások is, amikről olykor megfeledkezünk.
                                                Az erőforrások megismerése és mozgósítása felvértez minket a kihívásokkal és konfliktusokkal szemben az életünk során.
                                            </p>
                                            <p className={styles.serviceHeadingLead}>
                                                A segítő folyamat bizalmi és támogató környezetet biztosít a nehézségekkel való találkozásra, hogy minél inkább lehető legjobb önmagunkká válhassunk.
                                            </p>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {size.width < 1344 &&
                        <div className={styles.serviceHeadingSideMobile}>
                            <p className={styles.serviceHeadingLead}>
                                A személyes ülések biztonságos teret biztosítanak az érzelmek és a személyes tapasztalatok felfedezésére.
                                A közös munka lehetőséget teremt a hatékonyabb megküzdési készségek kialakítására a mindennapi élet kihívásival szemben és eszközöket kínál az egészségesebb kapcsolati működésre.
                                A tanácsadás során nemcsak a nehézségeknek van tere, kiemelt szerepet kapnak az erőforrások is, amikről olykor megfeledkezünk.
                                Az erőforrások megismerése és mozgósítása felvértez minket a kihívásokkal és konfliktusokkal szemben az életünk során.
                            </p>
                            <p className={styles.serviceHeadingLead}>
                                A segítő folyamat bizalmi és támogató környezetet biztosít a nehézségekkel való találkozásra, hogy minél inkább lehető legjobb önmagunkká válhassunk.
                            </p>
                        </div>
                    }
                </div>
                <div className={styles.serviceDetails}>
                    <h2 className={`${styles.headingSecondary} my-8`}>Mire számíthatsz?</h2>
                    <div className={styles.stepGrid}>
                        <div className={styles.stepNum}>0</div>
                        <div className={styles.stepDetail}>
                            A folyamatra, a bejelentkezésre vonatkozó vagy egyéb felmerülő kérdésre szívesen válaszolok a kapcsolat@szabojennifer.hu címen.
                        </div>
                        <div className={styles.stepNum}>1</div>
                        <div className={styles.stepDetail}>
                            A bejelentkezést és időpontegyeztetést követően az első találkozó előtt részletes e-mailt küldök a rendelő adataival és az érkezéssel kapcsolatban.
                        </div>
                        <div className={styles.stepNum}>2</div>
                        <div className={styles.stepDetail}>
                            Az első alkalom során közösen átbeszéljük a folyamat kereteit, hogy mindketten biztonságosan érezhessük magunkat, majd a hozott nehézség, kérdés, problémakör irányába fordulunk.
                        </div>
                        <div className={styles.stepNum}>3</div>
                        <div className={styles.stepDetail}>
                            A folyamat elején részletesen körüljárjuk a hozott témát, majd közösen feltárjuk a tanácsadás célját vagy céljait.
                        </div>
                        <div className={styles.stepNum}>4</div>
                        <div className={styles.stepDetail}>
                            Az ülések gyakoriságában közösen egyezünk meg a hozott téma, illetve az igények, szükségletek mentén.
                        </div>
                    </div>

                </div>
                <div className={styles.additionalInfo}>
                    <div className={styles.paramsGrid}>
                        <div className='flex flex-col gap-8'>
                            <div className={styles.paramName}>
                                <h3 className={styles.heading3rd}>Egy ülés ára</h3>
                            </div>
                            <div className={styles.paramValue}>
                                20.000 Ft
                            </div>
                        </div>
                        <div className='flex flex-col gap-8'>
                            <div className={styles.paramName}>
                                <h3 className={styles.heading3rd} >Hossza</h3>
                            </div>
                            <div className={styles.paramValue}>
                                50 perc
                            </div>
                        </div>
                    </div>

                    <div className={styles.cancellationInfo}>
                        <h3 className={styles.heading3rd}>Lemondási feltételek:</h3>
                        <p className={styles.paramValue}>
                            A foglalt időpontot térítésmentesen legkésőbb 4 nappal az időpont kezdete előtt lehetséges lemondani. 4 napon belüli lemondás esetén az ülés 50%-át szükséges kifizetni. 48 órán belüli lemondás esetén a Kliens köteles megtéríteni a konzultáció teljes díját. Ez a feltétel az első konzultációs alkalomra is érvényes.
                        </p>
                    </div>
                </div>
                <section className={styles.serviceCta}>
                    <CtaCard />
                </section>
            </main>
        </>
    )
}
